"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shortChatPane = void 0;

var _solidLogic = require("solid-logic");

var UI = _interopRequireWildcard(require("solid-ui"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*   Chat Pane
 **
 **  Plan is to support a finte number of chat graph shapes
 ** and investigate the interop between them.
 */

/* global $rdf */
var ns = UI.ns;
var shortChatPane = {
  icon: UI.icons.iconBase + 'noun_346319.svg',
  name: 'chat',

  /*
   * As part of the work on merging the existing chat views (aka panes) into one view
   * https://github.com/solid/chat-pane/issues/17
   * we want to dis-incentivize the use of Small Chat until we've gotten the work done
   * by making it difficult to create new data resources that uses the Small Chat view
   * but we still want existing resources to be viewed by the Small Chat view
   */
  audience: [ns.solid('PowerUser')],

  /*   AN RRSAgent IRC log:
   <irc://localhost:6667/&mit>
      a    foaf:ChatChannel
      foaf:chatEventList
              [ rdf:_100
                 <#T19-10-58>
              rdf:_101
                 <#T19-10-58-1>
              rdf:_102
  ..
  <#T19-28-47-1>
      dc:creator
         [ a wn:Person; foaf:nick "timbl" ]
      dc:date
         "2016-03-15T19:28:47Z"
      dc:description
         "timbl has joined &mit"
      a    foaf:chatEvent.
   */
  label: function label(subject, context) {
    var kb = context.session.store;
    var n = kb.each(subject, ns.wf('message')).length;
    if (n > 0) return 'Chat (' + n + ')'; // Show how many in hover text

    if (kb.holds(subject, ns.rdf('type'), ns.meeting('Chat'))) {
      // subject is the file
      return 'Meeting chat';
    }

    if (kb.holds(undefined, ns.rdf('type'), ns.foaf('ChatChannel'), subject)) {
      // subject is the file
      return 'IRC log'; // contains anything of this type
    }

    return null; // Suppress pane otherwise
  },
  mintClass: ns.meeting('Chat'),
  mintNew: function mintNew(context, newPaneOptions) {
    var kb = context.session.store;
    var updater = kb.updater;

    if (newPaneOptions.me && !newPaneOptions.me.uri) {
      throw new Error('chat mintNew:  Invalid userid ' + newPaneOptions.me);
    }

    var newInstance = newPaneOptions.newInstance = newPaneOptions.newInstance || kb.sym(newPaneOptions.newBase + 'index.ttl#this');
    var newChatDoc = newInstance.doc();
    kb.add(newInstance, ns.rdf('type'), ns.meeting('Chat'), newChatDoc);
    kb.add(newInstance, ns.dc('title'), 'Chat', newChatDoc);
    kb.add(newInstance, ns.dc('created'), new Date(), newChatDoc);

    if (newPaneOptions.me) {
      kb.add(newInstance, ns.dc('author'), newPaneOptions.me, newChatDoc);
    }

    return new Promise(function (resolve, reject) {
      updater.put(newChatDoc, kb.statementsMatching(undefined, undefined, undefined, newChatDoc), 'text/turtle', function (uri2, ok, message) {
        if (ok) {
          resolve(newPaneOptions);
        } else {
          reject(new Error('FAILED to save new tool at: ' + uri2 + ' : ' + message));
        }
      });
    });
  },
  render: function render(subject, context) {
    var kb = context.session.store;
    var dom = context.dom;

    var complain = function complain(message, color) {
      var pre = dom.createElement('pre');
      pre.setAttribute('style', 'background-color: ' + color || '#eed' + ';');
      div.appendChild(pre);
      pre.appendChild(dom.createTextNode(message));
    };

    var div = dom.createElement('div');
    div.setAttribute('class', 'chatPane');
    var options = {}; // Like newestFirst

    var messageStore;

    if (kb.holds(subject, ns.rdf('type'), ns.meeting('Chat'))) {
      // subject may be the file
      messageStore = subject.doc();
    } else if (kb.any(subject, UI.ns.wf('message'))) {
      messageStore = _solidLogic.store.any(subject, UI.ns.wf('message')).doc();
    } else if (kb.holds(undefined, ns.rdf('type'), ns.foaf('ChatChannel'), subject) || kb.holds(subject, ns.rdf('type'), ns.foaf('ChatChannel'))) {
      // subject is the file
      var ircLogQuery = function ircLogQuery() {
        var query = new $rdf.Query('IRC log entries');
        var v = [];
        var vv = ['chan', 'msg', 'date', 'list', 'pred', 'creator', 'content'];
        vv.map(function (x) {
          query.vars.push(v[x] = $rdf.variable(x));
        });
        query.pat.add(v.chan, ns.foaf('chatEventList'), v.list); // chatEventList

        query.pat.add(v.list, v.pred, v.msg); //

        query.pat.add(v.msg, ns.dc('date'), v.date);
        query.pat.add(v.msg, ns.dc('creator'), v.creator);
        query.pat.add(v.msg, ns.dc('description'), v.content);
        return query;
      };

      messageStore = subject.doc();
      options.query = ircLogQuery();
    } else {
      complain('Unknown chat type');
    } //    var context = {dom, div}
    //    UI.authn.logIn(context).then( context => { // The widget itself sees to login


    div.appendChild(UI.messageArea(dom, kb, subject, messageStore, options));
    kb.updater.addDownstreamChangeListener(messageStore, function () {
      UI.widgets.refreshTree(div);
    }); // Live update
    //    })

    return div;
  }
};
exports.shortChatPane = shortChatPane;
//# sourceMappingURL=shortChatPane.js.map